@use '../common/colors.scss' as colors;
@use '../common/vars.scss' as vars;

.accept {
  display: flex;
  flex-direction: column;
  width: 100%;

  .form-group span {
    margin-left: -44px;
  }
  @media screen and (max-width: vars.$mobile) {
    padding: 0 6px;
  }
}

.accept-terms {
  font-size: 0.75em;
  color: colors.$body-text;
}

.accept-header-wrapper {
  width: 60%;
  margin: 0 auto;
  text-align: center;

  h2 {
    font-size: 1em;
    font-weight: 500;
    margin-top: 1em;
    margin-bottom: 0.625em;
    line-height: 1.1;

    span {
      color: colors.$uplift-green;
    }
  }

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
    text-align: left;

    h2 {
      font-size: 0.75em;
    }
  }
}

.accept-subheader {
  font-size: 0.9em;
  margin-bottom: 0.9em;
  letter-spacing: -0.1px;
  color: colors.$body-text;
}

.accept-body {
  display: flex;
  flex-direction: column;
  width: 50%;
  margin: 0 auto 20px auto;

  @media screen and (max-width: vars.$tablet) {
    width: 60%;
  }

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
  }
}

.accept-inputs {
  display: flex;
  flex-wrap: wrap;
  margin-top: 1em;

  & > * {
    width: 100%;
    padding: 0 6px;

    @media screen and (max-width: vars.$mobile) {
      padding: 0;
    }
  }

  :global(.form-group) label {
    font-size: 14px;
  }
}

.accept-inputs-hidden {
  display: none;
}

.accept-input-third-desktop {
  width: 33.3333%;
  align-self: flex-end;

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
  }
}

.accept-input-header-wrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  margin-top: 2em;
  padding: 0 6px;

  @media screen and (max-width: vars.$mobile) {
    padding: 0;
  }
}

:global(.header-txt).accept-input-header {
  margin: 0;
  color: colors.$body-text;
  font-size: 24px;
  line-height: normal;
}

.accept-required-fields {
  font-size: 0.75em;
  line-height: normal;
}

.accept-payment-faq-button {
  border: none;
  display: inline-block;
  width: fit-content;
  background-color: #fff;
  padding: 0 6px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
  color: colors.$link;

  &:hover {
    color: colors.$link;
  }
}

.accept-payment-options-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 6px;

  & > *:last-child {
    margin-bottom: 0;
  }

  @media screen and (max-width: vars.$mobile) {
    padding: 0;
  }
}

.accept-payment-option-button {
  color: colors.$header;
  background-color: colors.$white;
  border: 1px solid #8c95a6;
  font-weight: 400;
  width: 100%;
  white-space: normal;
  line-height: 17px;
  text-align: left;
  position: relative;
  letter-spacing: -0.7px;
  padding: 0;
  margin-bottom: 1em;
  font-size: 0.875em;
  padding: 12px;
  border-radius: 8px;

  &:hover {
    background-color: #eff9f8;
  }
}

.accept-payment-method-error-wrapper {
  margin-top: -15px;
  padding: 0 6px;
}

.accept-select-payment-method-header {
  font-size: 0.875em;
  margin-bottom: 16px;
  line-height: normal;
}

.accept-payment-option-button:global(.selected) {
  border: 1px solid colors.$uplift-green;
  background-color: #eff9f8;
  font-weight: 600;
  border-radius: 8px;
}

.accept-payment-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
}

.accept-payment-option-text {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
}

.accept-plaid-loading-indicator {
  margin-top: 1em;
}

.accept-recommended {
  padding: 4px 8px;
  color: colors.$blue;
  background-color: #edeff9;
  border-radius: 4px;
  margin-left: 1em;
  font-weight: 400;
}

.accept-payment-option-desc {
  color: colors.$flexpay-body-text;
  line-height: 20px;
  margin-top: 8px;
}

.accept-card-icons {
  display: flex;

  :first-child {
    margin-right: 4px;
  }
}

.accept-bank-account-details-wrapper,
.accept-bank-account-details-wrapper-hidden {
  padding: 0 6px;
  display: flex;
  justify-content: space-between;
  color: colors.$label;
  letter-spacing: 0.25px;
  align-items: center;
  font-size: 0.875em;
  margin: 2em 0;

  span {
    padding-right: 5px;
  }

  @media screen and (max-width: vars.$mobile) {
    padding: 0;
  }
}

.accept-bank-account-details-wrapper-hidden {
  display: none;
}

.accept-bank-account-details {
  display: flex;

  & > * {
    margin-right: 5px;
  }
}

.accept-bank-account-edit button {
  font-size: 1em;
  font-weight: 600;
  text-decoration: underline;
  text-transform: uppercase;
  color: colors.$teal;
  border: none;
  background: none;

  &:hover {
    color: colors.$teal;
  }
}

.accept-plaid-ssn-input {
  padding: 0 6px;
}

.accept-form-submit {
  margin-bottom: 20px;
  font-size: 1.125em;
  padding: 10px 16px;
  margin-top: 24px;
}

.accept-form-submit:global(.disabled) {
  opacity: 0.1;
  cursor: not-allowed;
}

// Flexpay

:global(.flexpay) {
  .accept-payment-option-button:global(.selected),
  .accept-bank-account-edit button {
    font-weight: 500;
    border: 2px solid colors.$flexpay-link;
    background: #fefefe;
  }

  .accept-payment-option-button {
    border: 1px solid colors.$flexpay-border;

    &:hover {
      background-color: #fefefe;
    }
  }

  .accept-recommended {
    background: colors.$flexpay-light-blue;
    color: colors.$flexpay-link;
  }

  .accept-header-wrapper,
  .accept-body {
    max-width: 444px;
    width: 100%;
    padding: 0;

    @media screen and (max-width: vars.$tablet) {
      width: 100%;
    }
  }

  .accept-header-wrapper {
    text-align: left;
    h2 span {
      color: colors.$flexpay-green;
    }
  }

  .accept-subheader {
    color: colors.$flexpay-body-text;
  }

  .accept-inputs,
  .accept-plaid-ssn-input {
    i {
      color: colors.$flexpay-title !important;
    }
  }

  .accept-bank-account-edit button {
    color: colors.$flexpay-link;
  }

  .accept-payment-faq-button {
    color: colors.$flexpay-green;
    text-decoration: none;

    &:hover {
      color: colors.$flexpay-green;
    }
  }
}
